"use client";
import { VariantProps, cva } from "class-variance-authority";
import Badge from "~/components/Badge";
import useIsMobile from "~/hooks/useIsMobile";
import { EventBadges } from "~/types/EventTypes";
import { cn } from "~/utils/fontsConfig";

const badgeOverlayVariants = cva("absolute", {
    variants: {
        size: {
            large: "bottom-4 right-[10px] h-[60px]",
            default: "bottom-4 right-[10px] h-[50px]",
            sm: "bottom-2 flex h-[30px] right-[10px]",
        },
    },
    defaultVariants: {
        size: "default",
    },
});

const sizes = {
    large: 60,
    default: 50,
    sm: 30,
};

interface BadgeOverlayProps extends VariantProps<typeof badgeOverlayVariants> {
    badges: EventBadges;
    className?: string;
}
export const EventImageBadgeOverlay = ({
    badges,
    size,
    className,
}: BadgeOverlayProps) => {
    if (!badges.length) return null;

    const isMobile = useIsMobile();
    const badgeSize = isMobile ? sizes.sm : sizes[size || "default"];

    return (
        <ul
            className={cn(
                badgeOverlayVariants({ size: isMobile ? "sm" : size }),
                "flex w-full flex-nowrap justify-end gap-4",
                className,
            )}
        >
            {badges.slice(0, 3).map((_, index) => {
                const badge = badges[badges.length - index - 1]!;
                return (
                    <li key={badge.id} className="h-max w-max">
                        <Badge badge={badge} size={badgeSize} tooltip={false} />
                    </li>
                );
            })}
        </ul>
    );
};
